import { render, staticRenderFns } from "./BiLabel.vue?vue&type=template&id=27e0579b&scoped=true"
import script from "./BiLabel.vue?vue&type=script&lang=js"
export * from "./BiLabel.vue?vue&type=script&lang=js"
import style0 from "./BiLabel.vue?vue&type=style&index=0&id=27e0579b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0579b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e0579b')) {
      api.createRecord('27e0579b', component.options)
    } else {
      api.reload('27e0579b', component.options)
    }
    module.hot.accept("./BiLabel.vue?vue&type=template&id=27e0579b&scoped=true", function () {
      api.rerender('27e0579b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/BiLabel.vue"
export default component.exports